import React from "react";
import {observer} from "mobx-react";

import "./measurements-tab-pane.scss";

import {Tab} from "semantic-ui-react";

import {Kiwis, Station} from "../../../../../kiwis";
import {
    MeasurementsInfoConfiguration,
    MeasurementsInfoGroupTypeConfiguration, MeasurementsInfoSectionConfiguration
} from "../../../../../config/measurements-info-configuration";
import {MeasurementInfoSection} from "./measurement-info-section/measurement-info-section";

interface StationTabPaneProps {
    kiwis: Kiwis;
    station: Station;
    aspectRatio: number; // aspect ratio of parent windows
    active: boolean; // if tab is active,
    config: MeasurementsInfoConfiguration;
}

@observer
export class MeasurementsTabPane extends React.Component<StationTabPaneProps, any> {
    constructor(props: StationTabPaneProps) {
        super(props);
        this.state = {
            updating: false
        };
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        // TODO remove watches
    }

    render() {
        const {active, station, config} = this.props;

        // get applicable sections
        let sectionConfigs: MeasurementsInfoSectionConfiguration[] = [];
        config.grouping?.forEach((group: MeasurementsInfoGroupTypeConfiguration) => {
            if(group.baseIds.includes(station?.baseId)) {
                sectionConfigs = sectionConfigs.concat(group.sections);
            }
        });

        const sections = sectionConfigs.map((sectionConfiguration: MeasurementsInfoSectionConfiguration) => {
            return (
                <MeasurementInfoSection
                    station={station}
                    config={config}
                    divider={sectionConfigs.length > 1}
                    {...sectionConfiguration}
                    key={`measurements-pane-section-${sectionConfiguration.id}`}
                />
            );
        });

        return (
            <Tab.Pane
                key={`measurements-pane-${station.id}`}
                className={"measurements-tab-pane scrollable-content"}
                active={active}
            >
                {sections}
            </Tab.Pane>
        );
    }
}
